import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const VERSION = 0;
const URL = API_URL + "/saas/multi-tenancy/connection-uri-domain";

export async function removeMultiTenancyAppOrEnv(data: { deploymentId: string; appId: string }): Promise<void> {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000
    };

    await httpNetworking.simpleDELETERequest(
        `${URL}/${data.appId}?deploymentId=${data.deploymentId}`,
        options,
        VERSION
    );
}
